import React, { useEffect, useState } from 'react';
import { LeftArrow, RightArrow } from './ArrowBtns';

import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';

import { CardSharedMeme } from './CardSharedMeme';
import './index.styles.scss';
import ImageIcon from 'assets/svgs/ImageIcon';
import { apiGetContentMemes } from 'shared/api/content';
import { FullImageModal } from 'components/Modals/FullImageModal';

interface SharedMemesProps {
  selectedOrg: any;
  onShowAll: () => void;
}

export const SharedMemes = ({ selectedOrg, onShowAll }: SharedMemesProps) => {
  const [arrMeme, setArrMeme] = useState<Array<any>>([]);
  const [lastId, setLastId] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const [showFullImage, setShowFullImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState<any>(null);

  useEffect(() => {
    if (selectedOrg) {
      loadData();
    }
  }, [selectedOrg]);

  const loadData = async (init = true) => {
    if (init) {
      const res = await apiGetContentMemes({
        query: '',
        to: selectedOrg ? selectedOrg.id : undefined,
        to_type: 'organisation',
        limit: 10,
        offset: 0
      });

      if (res.success) {
        setArrMeme(res.data);
        setLastId(res.lastId);
        setHasMore(res.hasMore);
        setIsLoaded(true);
      }
    } else {
      if (!isLoading && hasMore) {
        const res = await apiGetContentMemes({
          query: '',
          to: selectedOrg ? selectedOrg.id : undefined,
          to_type: 'organisation',
          limit: 10,
          offset: lastId
        });

        if (res.success) {
          setArrMeme((prev) => [...prev, ...res.data]);
          setLastId(res.lastId);
          setHasMore(res.hasMore);
        }
      }
    }
  };

  const onWheel = (apiObj, ev) => {
    const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

    if (isThouchpad) {
      ev.stopPropagation();
      return;
    }

    if (ev.deltaY < 0) {
      apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
      apiObj.scrollPrev();
    }
  };

  const renderIntro = () => {
    return (
      <div className="intro_view" key="shared_meme_intro">
        <div className="mark_view">
          <ImageIcon color="white" />
        </div>
        <div
          className="font-bold font24"
          style={{ marginTop: 8 }}
        >{`Shared Memes\nwithin Schools`}</div>
        <div
          className="font-regular font14"
          style={{ color: 'rgba(0, 0, 0, 0.4)', marginTop: 8 }}
        >
          {`Capture and share \n moments with your friends!`}
        </div>
        <div
          className="font-bold font14 clickable"
          style={{ color: '#FF3E9A', marginTop: 8 }}
          onClick={onShowAll}
        >
          Show All
        </div>
      </div>
    );
  };

  const renderBody = () => {
    return (
      <div className="row_align_items" style={{ width: '100%' }}>
        {renderIntro()}
        <ScrollMenu
          LeftArrow={LeftArrow}
          RightArrow={RightArrow}
          onWheel={onWheel}
        >
          {arrMeme.map((item, index) => {
            return (
              <CardSharedMeme
                key={`card_shared_meme_${index}`}
                data={item}
                selectedOrg={selectedOrg}
                onClickedImage={(imgUrl) => {
                  setShowFullImage(true);
                  setSelectedImage(imgUrl);
                }}
              />
            );
          })}
        </ScrollMenu>
      </div>
    );
  };

  const renderFullImageView = () => {
    return (
      <FullImageModal
        show={showFullImage}
        onClose={() => setShowFullImage(false)}
        imageUrl={selectedImage}
      />
    );
  };

  if (selectedOrg && arrMeme.length > 1) {
    return (
      <div className="shared_meme_container">
        <div className="shared_meme">{renderBody()}</div>
        {renderFullImageView()}
      </div>
    );
  } else {
    return <div />;
  }
};
